export default {
  //公用课程名称，班级名称
  globalCourse:'',
  globalClass:'',
  delFile:'',
  // 测验难易度和题型
  testSelectDegree:{},
  testSelectType:{},
  uploadFile:'',
  testAdd:'',
  testEdit:'',
  testDel:'',
  testList:[],
  downExcel:'',
}
